// extracted by mini-css-extract-plugin
module.exports = {"image":"bb-module--image--ZnCgH","content":"bb-module--content--3Gs7f"};